import { render } from "./DashOpsPanel.vue?vue&type=template&id=15340272&scoped=true&ts=true"
import script from "./DashOpsPanel.vue?vue&type=script&lang=ts"
export * from "./DashOpsPanel.vue?vue&type=script&lang=ts"

import "./DashOpsPanel.vue?vue&type=style&index=0&id=15340272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15340272"]])

export default __exports__